var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ch-container"},[_c('div',{staticClass:"logo-bar"},[_c('el-row',[_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"ch-logo-box"},[_c('logo-view'),(_vm.loginFlag == 1)?_c('div',{staticClass:"text"},[_vm._v("供应商登录")]):_vm._e(),(_vm.loginFlag != 1)?_c('div',{staticClass:"text"},[_vm._v("采购方登录")]):_vm._e()],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }